'use strict';

import axios from 'axios';

export default {
  send: function(data) {
    let method = 'post';
    let url = window.Routes.contact.send;

    return axios({
      method: method,
      url: url,
      data: data
    }).then((response) => {
      return Promise.resolve(response.data);
    }).catch((error) => {
      return Promise.reject(error.response.data);
    });
  },
};
